import { cn } from "@/utils/cn";

type BrandLogoProps = {
  className?: string;
  compact?: boolean;
};

export default function BrandLogo({
  className = "",
  compact = false,
}: BrandLogoProps) {
  const kind = compact ? "icon" : "wordmark";

  return (
    <span
      className={cn(
        "relative inline-grid shrink-0",
        compact ? "w-8 aspect-[205/185]" : "w-[126px] aspect-[665/210]",
        className,
      )}
    >
      <img
        className={cn(
          "col-start-1 row-start-1 size-full object-contain",
          "dark:opacity-0",
        )}
        src={`/brand/ours-${kind}-purple.svg`}
        alt="ours"
      />
      <img
        aria-hidden="true"
        className={cn(
          "col-start-1 row-start-1 size-full object-contain opacity-0",
          "dark:opacity-100",
        )}
        src={`/brand/ours-${kind}-lime.svg`}
        alt=""
      />
    </span>
  );
}
